import {Button, Menu, MenuHandler, MenuItem, MenuList, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {getConsultationFieldAgentBranchFees} from "../../services/agent_branch_fee/agent_branch_fee";
import {BsCurrencyDollar} from "react-icons/bs";

export function AgentPanelConsultationMenu({agentId, branch_id, fieldId, setAgentId, setBranchId}) {

  const [fieldAgentBranchFees, setFieldAgentBranchFees] = useState([]);
  const [openMenu, setOpenMenu] = useState(branch_id ? true : false);
  const [dataLoaded, setDataLoaded] = useState(false);

  function reOrderBranches(field_agent_branch_fee) {
    let selectedBranch;
    for (let branch of field_agent_branch_fee) {
      if (branch.id === parseInt(branch_id)) {
        selectedBranch = branch;
        break;
      }
    }

    if (!selectedBranch) {
      return
    }

    const index = field_agent_branch_fee.indexOf(selectedBranch);
    field_agent_branch_fee.splice(index, 1);
    // Insert the selected agent at the first position of the list
    field_agent_branch_fee.unshift(selectedBranch);
    return field_agent_branch_fee;
  }

  async function getAgentFieldData() {
    setDataLoaded(false);
    const data = new URLSearchParams({
      field_id: fieldId,
      agent_id: agentId,
    }).toString()
    const result = await getConsultationFieldAgentBranchFees(data);
    if (result.status === 200) {
      let {field_agent_branch_fee} = result.data;
      if (branch_id && field_agent_branch_fee) {
        field_agent_branch_fee = reOrderBranches(field_agent_branch_fee)
      }
      setFieldAgentBranchFees(field_agent_branch_fee)
      setDataLoaded(true);
    }
  }

  useEffect(() => {
    if (openMenu) {
      getAgentFieldData();
    }
  }, [openMenu]);


  return (
    <Menu placement="bottom" open={openMenu} handler={setOpenMenu}>
      <MenuHandler>
        <Button className={`w-fit`} variant={`${dataLoaded && openMenu ? "gradient" : "outlined"}`} onClick={() => {
          setOpenMenu(!openMenu)
        }}>
          دریافت مشاوره
        </Button>
      </MenuHandler>
      <MenuList className="flex flex-col gap-2 max-h-72">
        {dataLoaded && fieldAgentBranchFees?.map(({id, branch_title, price}, index) => (
            <>
              <MenuItem className="flex flex-col pl-2 gap-y-2"
                        onClick={() => {
                          setOpenMenu(!openMenu)
                          setAgentId(agentId)
                          setBranchId(id)
                        }}>
                <div className="flex flex-row">
                  <Typography variant="h6" color="gray" className="font-semibold">
                    {`گرایش: ${branch_title}`}
                  </Typography>
                </div>
                <div className="flex flex-row">
                  <Typography className="flex items-center gap-1 text-sm font-medium text-blue-gray-500">
                    <BsCurrencyDollar/>
                    {`هر دقیقه مشاوره: ${persianNumberFormat(price, true)} ریال`}
                  </Typography>
                </div>
              </MenuItem>
              {index !== fieldAgentBranchFees.length - 1 &&
                <hr className=""/>
              }
            </>
          )
        )
        }
        {!dataLoaded &&
          <MenuItem className="flex flex-col items-center gap-4 py-2 pl-2 pr-8">
            <div className="flex flex-row gap-1">
              <Typography variant="small" color="gray" className="font-semibold">
                در حال دریافت اطلاعات ....
              </Typography>
            </div>

          </MenuItem>
        }
      </MenuList>
    </Menu>
  );
}
